import { createState, useState } from "@hookstate/core";
const initialState = {
	element: "home",
};

const headerState = createState(initialState);

export const setHeaderState = (props) => {
	headerState.set({
		...initialState,
		element: props,
	});
};

export const useHeaderState = () => {
	return useState(headerState);
};
